import actionTypes from './actionTypes'

const navigationMenuActions = {
	helpInitialize: () => ({
		type: actionTypes.NAVIGATION_MENU_HELP_INITIALIZE,
	}),

	helpHelpCenterSelected: () => ({
		type: actionTypes.NAVIGATION_MENU_HELP_HELP_CENTER_SELECTED,
	}),

	helpTeacherResourcesSelected: () => ({
		type: actionTypes.NAVIGATION_MENU_HELP_TEACHER_RESOURCES_SELECTED,
	}),

	helpWhatsNewSelected: () => ({
		type: actionTypes.NAVIGATION_MENU_HELP_WHATS_NEW_SELECTED,
	}),

	helpPersonalizedNewsSelected: () => ({
		type: actionTypes.NAVIGATION_MENU_HELP_PERSONALIZED_NEWS_SELECTED,
	}),

	helpContactUsSelected: () => ({
		type: actionTypes.NAVIGATION_MENU_HELP_CONTACT_US_SELECTED,
	}),

	helpOnboardingGuideSelected: () => ({
		type: actionTypes.NAVIGATION_MENU_HELP_ONBOARDING_GUIDE_SELECTED,
	}),

	notificationPreferencesInitialize: () => ({
		type: actionTypes.NAVIGATION_MENU_NOTIFICATION_PREFERENCES_INITIALIZE,
	}),

	notificationPreferencesFetched: notifications => ({
		type: actionTypes.NAVIGATION_MENU_NOTIFICATION_PREFERENCES_FETCHED,
		notifications,
	}),

	notificationPreferencesFailed: serverError => ({
		type: actionTypes.NAVIGATION_MENU_NOTIFICATION_PREFERENCES_FAILED,
		serverError,
	}),

	updateEmailNotification: value => ({
		type:
			actionTypes.NAVIGATION_MENU_NOTIFICATION_PREFERENCES_EMAIL_NOTIFICATION_ENABLED,
		value,
	}),

	updateEmailNotificationSuccess: () => ({
		type:
			actionTypes.NAVIGATION_MENU_NOTIFICATION_PREFERENCES_EMAIL_NOTIFICATION_ENABLED_SUCCESS,
	}),

	updateEmailNotificationFailed: serverError => ({
		type:
			actionTypes.NAVIGATION_MENU_NOTIFICATION_PREFERENCES_EMAIL_NOTIFICATION_ENABLED_FAILED,
		serverError,
	}),

	logout: isImpersonate => ({
		type: actionTypes.NAVIGATION_MENU_MAIN_LOGOUT_SELECTED,
		isImpersonate,
	}),

	logoutMetricsSuccess: () => ({
		type: actionTypes.NAVIGATION_MENU_MAIN_LOGOUT_METRICS_SUCCESS,
	}),

	accountSelected: () => ({
		type: actionTypes.NAVIGATION_MENU_MAIN_ACCOUNT_SELECTED,
	}),

	accountMetricsSuccess: () => ({
		type: actionTypes.NAVIGATION_MENU_MAIN_ACCOUNT_METRICS_SUCCESS,
	}),

	navigationMenuUpgradeSelected: redirectUrl => ({
		type: actionTypes.NAVIGATION_MENU_UPGRADE_SELECTED,
		redirectUrl,
	}),

	updateProfileImageSelected: () => ({
		type: actionTypes.NAVIGATION_MENU_MAIN_UPDATE_PROFILE_IMAGE_SELECTED,
	}),

	manageSelected: redirectUrl => ({
		type: actionTypes.NAVIGATION_MENU_MAIN_MANAGE_SELECTED,
		redirectUrl,
	}),

	settingsSelected: () => ({
		type: actionTypes.NAVIGATION_MENU_MAIN_SETTINGS_SELECTED,
	}),

	settingsMetricsSuccess: () => ({
		type: actionTypes.NAVIGATION_MENU_MAIN_SETTINGS_METRICS_SUCCESS,
	}),

	notificationPreferencesSelected: () => ({
		type: actionTypes.NAVIGATION_MENU_NOTIFICATION_PREFERENCES_SELECTED,
	}),
}

export default navigationMenuActions
